import char2 from './Assets/Media/char1.png'
import char1 from './Assets/Media/char2.png'
import char3 from './Assets/Media/char3.png'
let characters = [char1,char2,char3]
export default characters;